import { css } from "@emotion/react";
import styled from "@emotion/styled";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import YouTube from "@vip30/react-youtube";

const VolumeControlIconStyle = css`
  inline-size: 36px;
  block-size: 36px;

  color: #ffffff;

  cursor: pointer;
`;

export const StyledMuteIcon = styled(VolumeUpIcon)`
  ${VolumeControlIconStyle}
`;
export const StyledUnmuteIcon = styled(VolumeOffIcon)`
  ${VolumeControlIconStyle}
`;

type ContainerProps = {
  $orientation?: "landscape" | "portrait";
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;

  inline-size: 100%;
  margin-inline: auto;

  ${props =>
    props.$orientation === "portrait"
      ? css`
          inline-size: var(--portrait-inline-size);
          .ima-ad-player {
            > div {
              inset-block-start: 100%;
            }
          }

          ${VideoContainer} {
            inline-size: var(--portrait-inline-size);
            block-size: auto;
            aspect-ratio: 9/16;

            ${StyledYouTube} {
              iframe {
                inline-size: var(--portrait-inline-size);

                aspect-ratio: 9/16;
              }
            }
          }
        `
      : null}
`;

export const StyledYouTube = styled(YouTube)`
  position: absolute;

  inline-size: 100%;
  block-size: auto;

  iframe {
    inline-size: 100%;
    block-size: 100%;
  }
`;

export const VideoContainer = styled.div`
  position: relative;

  inline-size: 100%;
  block-size: auto;
`;

export const AdControlButtonContainer = styled.div`
  position: absolute;
  inset-block: 0 0;
  inset-inline-start: 0;
  z-index: 1;
`;

export const AdContainer = styled.div`
  position: absolute;
  inset-inline-start: 0;

  .ima-ad-player > div {
    position: unset !important;
  }
`;
